import flatpickr from "flatpickr";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
flatpickr.localize(Turkish);

let __dtHandler = {

    instances: {},

}

let __dateHandler = {

    instances: {},

}

Array.from(document.querySelectorAll('.datetimepicker')).forEach(function(dtpicker) {

    let options = {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        minuteIncrement: 30,
        time_24hr: true,
        defaultHour: 0,
        monthSelectorType: 'static',
        altInput: true,
        onChange: function(dateObject, dateString, instance) {

            if (dtpicker.getAttribute('data-onchange')) {
                let callback = dtpicker.getAttribute('data-onchange');
                __dtHandler[callback](dateObject, dateString, instance);
            }
        },
        onOpen: function(dateObject, dateString, instance) {
            if (dtpicker.getAttribute('data-onopen')) {
                let callback = dtpicker.getAttribute('data-onopen');
                __dtHandler[callback](dateObject, dateString, instance);
            }
        }
    };

    if (dtpicker.getAttribute('data-mode')) {
        options['mode'] = dtpicker.getAttribute('data-mode');
    }

    if (dtpicker.getAttribute('data-time')) {
        if (dtpicker.getAttribute('data-time') == 'false') {
            options['enableTime'] = false;
        }
    }

    if (dtpicker.getAttribute('data-dateformat')) {
        options['dateFormat'] = dtpicker.getAttribute('data-dateformat');
    }

    if (dtpicker.getAttribute('data-mindate')) {
        options['minDate'] = dtpicker.getAttribute('data-mindate');
    }

    if (dtpicker.getAttribute('data-nocalendar')) {
        if (dtpicker.getAttribute('data-nocalendar') == 'true') {
            options['noCalendar'] = true;
        }
    }

    let name = dtpicker.getAttribute('name');

    __dtHandler.instances[name] = flatpickr(dtpicker, options);
});


Array.from(document.querySelectorAll('.datepicker')).forEach(function(dpicker) {
    let options = {
        enableTime: false,
        dateFormat: "Y-m-d",
        defaultHour: 0,
        monthSelectorType: 'static',
    };

    let name = dpicker.getAttribute('name');

    __dateHandler.instances[name] = flatpickr(dpicker, options);
});
